import { toast } from 'react-toastify';
import SuccessToast from './SuccessToast';
import ErrorToast from './ErrorToast';
import ConfirmationToast from "./ConfirmationToast";

export const showSuccessToast = (textArray) => {
    toast.success(<SuccessToast textArray={textArray}/>, {
        position: toast.POSITION.TOP_RIGHT,
        pauseOnHover: true,
        autoClose: 7000, // 7 sec
    });
};

export const showErrorToast = (textArray) => {
    toast.error(<ErrorToast textArray={textArray}/>, {
        position: toast.POSITION.TOP_RIGHT,
        pauseOnHover: true,
        autoClose: 7000, // 7 sec
    });
};

export const showConfirmationToast = (text, onConfirm, onCancel) => {
    toast(<ConfirmationToast text={text} onConfirm={onConfirm} onCancel={onCancel}/>, {
        autoClose: false
    });
}